export function client (state) {
    return state.client
}

export function address (state) {
    return state.address
}